import FormattedMessage from 'I18n/components/FormattedMessage';
import { NextIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { WHY_GO_HUBSPOT_CARD } from '../constants/tracking/TrackingSources';
import { usePageParams } from '../hooks/usePageParams';
import { useAppSelector } from '../reducers';
import { navItemForProductLineSelector } from '../selectors/RoutingSelectors';
import { trackClickedLink } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductLineToColor = {
  [MARKETING]: 'fill-accent-blue-default',
  [SALES]: 'fill-positive-pressed',
  [SERVICE]: 'fill-accent-purple-default',
  [OPERATIONS]: 'fill-caution-pressed',
  [CMS]: 'fill-accent-light-orange-default',
  [COMMERCE]: 'fill-accent-magenta-default'
};
const backgroundColor = 'fill-surface-default';
const padding = '400';
const WhyGoHubSpotTile = ({
  productLine
}) => {
  const {
    tab
  } = usePageParams();
  const hasTabbedPage = productLine !== COMMERCE;
  const navItem = useAppSelector(state => navItemForProductLineSelector(state, productLine));
  const path = `/${navItem}${tab && hasTabbedPage ? `/${tab}` : ''}`;
  const handleExploreClick = () => {
    trackClickedLink({
      name: 'explore-link',
      value: getI18nText(`whyGoHubSpot.${productLine}.explore`, {
        locale: 'en-us'
      }),
      type: 'internal',
      url: path,
      trackingSource: WHY_GO_HUBSPOT_CARD
    });
  };
  return /*#__PURE__*/_jsxs(CardWrapper, {
    flexDirection: "column",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: ProductLineToColor[productLine],
        padding: padding,
        children: /*#__PURE__*/_jsx(Text, {
          as: "h3",
          color: "text-primary-on-fill-default",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${productLine}.title`
          })
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: backgroundColor,
        padding: padding,
        children: /*#__PURE__*/_jsx(Text, {
          as: "div",
          textAlign: "center",
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${productLine}.primary`
          })
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: backgroundColor,
        padding: padding,
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${productLine}.subCopy`
          })
        })
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      flexGrow: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "end",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: backgroundColor,
        padding: padding,
        children: /*#__PURE__*/_jsx(RouterLink, {
          to: createToObject(path),
          onClick: handleExploreClick,
          children: /*#__PURE__*/_jsxs(Flex, {
            justifyContent: "center",
            alignItems: "end",
            gap: "300",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: `whyGoHubSpot.${productLine}.explore`
            }), /*#__PURE__*/_jsx(View, {
              inlineSize: "24px",
              blockSize: "24px",
              children: /*#__PURE__*/_jsx(NextIcon, {
                size: "600"
              })
            })]
          })
        })
      })
    })]
  });
};
export default WhyGoHubSpotTile;